import React from 'react'
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div>
      <footer className="footer">
        <div className="container">
          <div className="footer-main">
            <div className="footer-column footer-company">
              <h3>DMCO</h3>
              <p>Global Material Solutions</p>
            </div>

            <div className="footer-column footer-head-office">
              <h4>Head Office</h4>
              <ul className="contact-info">
                <li>2nd Industrial City, 95 St., </li>
                <li>Dammam, Saudi Arabia </li>
                <li>P.O Box : 5713, Dammam 31432</li>
                <li>Email: <a href="info@mawad-drilling.com">info@mawad-drilling.com</a></li>
                <li>Website: <a href="https://www.drilling-materials.com" target="_blank" rel="noreferrer">https://www.drilling-materials.com</a></li>
              </ul>
            </div>

            <div className="footer-column footer-support">
              <h4>Support</h4>
              <ul>
                <li><Link to="/contactus">Contact Us</Link></li>
                <li><Link to="/faq">FAQs</Link></li>
                {/* <li><Link to="/#">Help Center</Link></li> */}

                {/* <li><a href="/#">Contact Us</a></li>
                <li><a href="/#">FAQs</a></li>
                <li><a href="/#">Help Center</a></li> */}
              </ul>
            </div>

            <div className="footer-column footer-social">
              <h4>Follow Us</h4>
              <div className="social-icons">
                <Link to="/#"><i className="fab fa-linkedin-in"></i></Link>
                <Link to="/#"><i className="fab fa-facebook-f"></i></Link>
                <Link to="/#"><i className="fab fa-x-twitter"></i></Link>
                {/* <a href="/#"><i className="fab fa-linkedin-in"></i></a>
                <a href="/#"><i className="fab fa-facebook-f"></i></a>
                <a href="/#"><i className="fab fa-x-twitter"></i></a> */}
              </div>
            </div>
          </div>    
        </div>


        <div className="footer-bottom">
          <div className="container">
            <div className="footer-legal">
              <a href="/#">Privacy Policy</a> |
              <a href="/#">Disclaimer</a> |
              <a href="/#">Cookie Policy</a> |
              <a href="/#">Terms and Conditions and Legal Documents</a>
            </div>
            <div className="footer-copy">© DMCO 2025</div>
          </div>
        </div>
      </footer>              
    </div>
  )
}

export default Footer